export enum ROUTE_ORGANISATIONS {
  organisations = '/organisations',
  organisationMembers = '/organisations/:code/members',
  organisationSettings = '/organisations/:code/settings',
  addMember = '/organisations/:code/members/add-member',
  editMember = '/organisations/:code/members/:userId/edit',
}
